import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class WhatsappPhoneNumberService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.WHATSAPP_PHONE_NUMBER = '/api/whatsapp-phone-number';

        this.REGISTER = '/register';
        this.GET_LIST_BY_LEADS_ID = '/get/list/{leadsId}';
        this.GET_LIST_BY_PROJECT_ID = '/get/project/list/{projectId}';
    }

    async getPhoneNumberListByLeadsId(leadsId) {
        try {
            let url = window.location.origin + this.WHATSAPP_PHONE_NUMBER + this.GET_LIST_BY_LEADS_ID;
            url = url
                .replace('{leadsId}', leadsId);
            const phoneNumberList = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return phoneNumberList;
        } catch(err) {
            console.log(err);
        }
    }

    async getPhoneNumberListByProjectId(projectId) {
        try {
            let url = window.location.origin + this.WHATSAPP_PHONE_NUMBER + this.GET_LIST_BY_PROJECT_ID;
            url = url
                .replace('{projectId}', projectId);
            const phoneNumberList = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return phoneNumberList;
        } catch(err) {
            console.log(err);
        }
    }

    async registerPhoneNumber(body) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.WHATSAPP_PHONE_NUMBER + this.REGISTER;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default WhatsappPhoneNumberService;
